var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ui-chips", {
        attrs: {
          error: _vm.emailInvalidText,
          formatter: _vm.validateEmail,
          placeholder: "Add e-mail...",
          required: "",
        },
        model: {
          value: _vm.emails,
          callback: function ($$v) {
            _vm.emails = $$v
          },
          expression: "emails",
        },
      }),
      _vm._v(" "),
      _c(
        "ui-dialog-footer",
        [
          _c("ui-button", {
            attrs: {
              disabled:
                _vm.isFetching || (_vm.lifetime <= 0 && _vm.expires === 0),
              primary: "",
              text: "Send e-mail",
              tooltip: "Send e-mail with link to added recipients",
            },
            on: {
              click: function ($event) {
                _vm.emails.length > 0 && _vm.sendEmail()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }